import React, { useState, useCallback, useEffect } from "react";
import Select from "react-select";
import Draggable from "react-draggable";
import { useTranslation } from "react-i18next";
import {
  Button,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import swal from "sweetalert";
import DatePicker from "react-datepicker";
import {
  applyClassToCharacters,
  convertToDateString,
  getStringFromJSX,
  isUrdu,
  LoadingSpinner,
} from "../../constants/const";
import { encryptStorage } from "../../constants/EncryptStorage";
import { ApiAhbab } from "../ahbab/ApiAhbab";
import { GetLanguageString } from "../helper/Components";
import { GetSelectedLanguage } from "../helper/Method";
import { addMember } from "../member/ApiMember";
import SelectSerialNumber from "../member/SelectSerialNumber";
import { ApiUnitMember } from "../unit/ApiUnit";
import SelectUnitRequestMoveMember from "../unit/SelectUnitRequestMoveMember";
import { ApiMonthlyReports } from "../unit/MonthlyReports/ApiMonthlyReports";
import { ApiMemberTypeRequest } from "../member/MemberType/ApiMemberTypeRequest";
import { ApiFinance as ApiFinance2 } from "../funds/ApiFinance";
import { ApiFund } from "../funds/ApiFund";
import { viewReceiptPdf } from "../shared/receiptViewer";
import { ApiFinance } from "../config/finance/ApiFinance";

const ACTION_TYPES = {
  APPROVE: 1,
  REJECT: 2,
  HOLD: 3,
};

const NotificationAction = ({
  setActionModal,
  notificationName,
  notificationId,
  setRefreshList,
  unitId,
  isMemberMubtadi,
  isNotificationForwarded,
  memberName,
  canBeTransferredOutside,
  selectedRecord,
}) => {
  const { t } = useTranslation();
  const memberId = parseInt(encryptStorage.getItem("memberId"));
  const responsibilityId = parseInt(encryptStorage.getItem("responsibilityId"));
  const unitTypeName = encryptStorage.getItem("unitTypeName");
  const isAmanatShare =
    (notificationName === "req_halqa_share" || notificationName === "req_markaz_share") &&
    (selectedRecord?.paramsJSON?.source_account_type === "amanat" ||
     selectedRecord?.paramsJSON?.SourceAccountType === "amanat");

  const [errors, setErrors] = useState({});

  const [state, setState] = useState({
    position: { x: 0, y: 0 },
    unit: { value: unitId, label: "" },
    letterWrittenDate: new Date(),
    defaulValue: true,
    buttonDisable: false,
    loading: false,
    serialNumber: null,
    notificationAction: {
      code:
        isNotificationForwarded && !notificationName.includes("req_move_member")
          ? ACTION_TYPES.REJECT
          : ACTION_TYPES.APPROVE,
      notificationId,
      createdById: memberId,
      responsibilityId,
      comments: "",
      unitId,
      serialNumber: 0,
      feedback: "",
      letterWrittenDate: "",
      answerFromRafiq: true,
      generateNewNotification: false,
    },
  });

  const [hasBankDetails, setHasBankDetails] = useState(false);
  const [bankDetails, setBankDetails] = useState(null);
  const [dimension2Options, setDimension2Options] = useState([]);
  const [selectedDimension2, setSelectedDimension2] = useState(null);
  const [dimension2Error, setDimension2Error] = useState("");

  useEffect(() => {
    if (notificationName === "req_expense_from_amanat" || notificationName === "req_edit_expense_from_amanat") {
      setState((prev) => ({ ...prev, loading: true }));
      ApiFinance2()
        .GetOtherIncomeDataForNotification(notificationId)
        .then((res) => {
          if (res.data && (res.data.rafiqAccountTitle || res.data.rafiqAccountNumber)) {
            setHasBankDetails(true);
            setBankDetails(res.data);
            ApiFinance()
              .GetFinanceDimensionsListFromFinanceSoftware()
              .then((resDim) => {
                if (resDim.data) {
                  setDimension2Options(resDim.data);
                  if (res.data.rafiqAccountNumber) {
                    const accNum = res.data.rafiqAccountNumber.trim();
                    const matched = resDim.data.find(opt => opt.label && opt.label.includes(accNum));
                    if (matched) {
                      setSelectedDimension2(matched);
                    }
                  }
                }
              })
              .catch(console.error);
          }
        })
        .catch(console.error)
        .finally(() => {
          setState((prev) => ({ ...prev, loading: false }));
        });
    }
  }, [notificationId, notificationName]);

  const handleDrag = useCallback((e, ui) => {
    setState((prev) => ({
      ...prev,
      position: {
        x: prev.position.x + ui.deltaX,
        y: prev.position.y + ui.deltaY,
      },
    }));
  }, []);

  const toggle = () => setActionModal(false);

  const handleApprovalStatus = (code) => {
    setState((prev) => ({
      ...prev,
      defaulValue: code === ACTION_TYPES.APPROVE,
      notificationAction: {
        ...prev.notificationAction,
        code,
      },
    }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setState((prev) => ({
      ...prev,
      notificationAction: {
        ...prev.notificationAction,
        [name]: value,
      },
    }));
  };

  const handleDateChange = (date) => {
    setState((prev) => ({
      ...prev,
      letterWrittenDate: date,
    }));
  };

  const handleAnswerFromRafiq = (answer) => {
    setState((prev) => ({
      ...prev,
      notificationAction: {
        ...prev.notificationAction,
        answerFromRafiq: answer,
      },
    }));
  };

  const setSerialNumber = useCallback((number) => {
    setState((prev) => ({
      ...prev,
      serialNumber: number,
    }));
  }, []);

  const apiConfig = {
    req_move_member: () =>
      ApiUnitMember().moveMemberDataSave({
        ...state.notificationAction,
        unitId: state.unit.value,
      }),

    req_move_habib: () =>
      ApiAhbab().MoveHabibDataSave({
        ...state.notificationAction,
        unitId: state.unit.value,
      }),

    req_add_new_rafiq: () =>
      addMember().AddNewMember({
        ...state.notificationAction,
        serialNumber: state.serialNumber,
      }),

    req_assign_responsibility: () =>
      isMemberMubtadi &&
        !notificationName.includes("exception") &&
        state.notificationAction.code === ACTION_TYPES.APPROVE
        ? addMember().MemberResponsbilityRequestForward(
          state.notificationAction,
        )
        : addMember().MemberResponsibilityRequestApproval(
          state.notificationAction,
        ),

    req_exception_assign_responsibility: () =>
      addMember().MemberResponsibilityRequestApproval(state.notificationAction),

    req_monthly_report_muqami_tanzeem: () =>
      ApiMonthlyReports().MonthlyReportNotificationApproval(
        state.notificationAction,
      ),

    req_monthly_report_usra: () =>
      ApiMonthlyReports().MonthlyReportNotificationApproval(
        state.notificationAction,
      ),

    member_type_change_request_multazim_usra_to_tanzeem: () =>
      ApiMemberTypeRequest().ForwardMemberTypeRequest(state.notificationAction),

    member_type_change_request_multazim_usra_to_halqa: () =>
      ApiMemberTypeRequest().ForwardMemberTypeRequest(state.notificationAction),

    member_type_change_request_multazim_tanzeem_to_halqa: () =>
      ApiMemberTypeRequest().ForwardMemberTypeRequest(state.notificationAction),

    member_type_change_request_multazim_halqa_to_markaz: () =>
      ApiMemberTypeRequest().ApproveMemberChangeRequest(
        state.notificationAction,
      ),

    member_type_change_request_tawajah_talab_tanzeem_to_halqa: () =>
      ApiMemberTypeRequest().ForwardMemberTypeRequest(state.notificationAction),

    member_type_change_request_tawajah_talab_halqa_to_markaz: () =>
      ApiMemberTypeRequest().ApproveMemberChangeRequest(
        state.notificationAction,
      ),
    member_type_change_request_muatazir_tanzeem_to_halqa: () =>
      ApiMemberTypeRequest().ForwardMemberTypeRequest(state.notificationAction),

    member_type_change_request_muatazir_halqa_to_markaz: () =>
      ApiMemberTypeRequest().ApproveMemberChangeRequest(
        state.notificationAction,
      ),

    req_mark_rafiq_ex_halqa_level: () =>
      addMember().MarkMemberAsExForwardToNaibNazimAlla(
        state.notificationAction,
      ),

    req_mark_rafiq_ex_naib_nazim_alla_level: () =>
      addMember().MarkMemberAsExForwardToNazimAlla(state.notificationAction),

    req_mark_rafiq_ex_nazim_alla_level: () =>
      addMember().MarkMemberAsExRequestAction({
        ...state.notificationAction,
        letterWrittenDate: convertToDateString(state.letterWrittenDate),
      }),

    req_loan_from_markaz: () =>
      ApiFinance2().ApproveOtherIncomeLoanFromMarkaz({
        ...state.notificationAction,
      }),

    req_mod_loan_from_markaz: () =>
      ApiFinance2().ApproveModificationOtherIncomeLoanFromMarkaz({
        ...state.notificationAction,
      }),

    req_reimbursment_tarbiati_course: () =>
      ApiFinance2().ApproveOtherIncomeTarbiatiCourseReimbursment({
        ...state.notificationAction,
      }),

    req_mod_reimbursment_tarbiati_course: () =>
      ApiFinance2().ApproveModificationOtherIncomeTarbiatiCourseReimbursment({
        ...state.notificationAction,
      }),

    req_help_from_muqami_tanzeem: () =>
      ApiFinance2().ApproveOtherIncomeHelpFromMuqamiTanzeem({
        ...state.notificationAction,
      }),

    req_mod_help_from_muqami_tanzeem: () =>
      ApiFinance2().ApproveModificationOtherIncomeHelpFromMuqamiTanzeem({
        ...state.notificationAction,
      }),

    req_expense_from_amanat: () =>
      ApiFinance2().ApproveExpenseFromAmanat({
        ...state.notificationAction,
        dimension2Id: selectedDimension2?.value || 0,
      }),
    req_edit_expense_from_amanat: () =>
      ApiFinance2().ApproveEditExpenseFromAmanat({
        ...state.notificationAction,
        dimension2Id: selectedDimension2?.value || 0,
      }),
    req_expense_from_cash_in_hand: () =>
      ApiFinance2().ApproveExpenseFromCashInHand({
        ...state.notificationAction,
      }),
    req_edit_expense_from_cash_in_hand: () =>
      ApiFinance2().ApproveExpenseFromCashInHand({
        ...state.notificationAction,
      }),
    req_asset_donation: () =>
      ApiFinance2().ApproveAssetDonation({
        ...state.notificationAction,
      }),
    req_halqa_share: () =>
      ApiFinance2().ApproveHalqaShareExpense({
        ...state.notificationAction,
      }),
    req_edit_halqa_share: () =>
      ApiFinance2().ApproveHalqaShareExpense({
        ...state.notificationAction,
      }),
    req_delete_halqa_share: () =>
      ApiFinance2().ApproveHalqaShareExpense({
        ...state.notificationAction,
      }),
    req_markaz_share: () =>
      ApiFinance2().ApproveMarkazShareTransfer({
        ...state.notificationAction,
      }),
    req_edit_markaz_share: () =>
      ApiFinance2().ApproveMarkazShareTransfer({
        ...state.notificationAction,
      }),
    req_delete_markaz_share: () =>
      ApiFinance2().ApproveMarkazShareTransfer({
        ...state.notificationAction,
      }),
    req_usra_infaq_remittance: () =>
      ApiFund().UsraRemittanceAction(state.notificationAction),
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const isForwardingExpenseFromAmanat =
      (notificationName === "req_expense_from_amanat" || notificationName === "req_edit_expense_from_amanat") &&
      (unitTypeName === "Tanzeem" || unitTypeName === "Halqa");

    if (
      (notificationName === "req_expense_from_amanat" || notificationName === "req_edit_expense_from_amanat") &&
      !isForwardingExpenseFromAmanat &&
      hasBankDetails &&
      state.notificationAction.code === ACTION_TYPES.APPROVE &&
      !selectedDimension2
    ) {
      setDimension2Error("Please select Dimension 2 for this request before proceeding.");
      return;
    }

    const shouldTrigger =
      Object.keys(errors).length === 0 ||
      Object.values(errors).every((val) => val === "");

    if (!shouldTrigger) return;

    setState((prev) => ({ ...prev, buttonDisable: true, loading: true }));

    try {
      const apiCall = apiConfig[notificationName];
      if (!apiCall) return;

      const res = await apiCall();
      const isFinanceNotification =
        notificationName === "req_loan_from_markaz" ||
        notificationName === "req_reimbursment_tarbiati_course" ||
        notificationName === "req_help_from_muqami_tanzeem" ||
        notificationName === "req_expense_from_amanat" ||
        notificationName === "req_edit_expense_from_amanat" ||
        notificationName === "req_expense_from_cash_in_hand" ||
        notificationName === "req_edit_expense_from_cash_in_hand" ||
        notificationName === "req_asset_donation" ||
        notificationName === "req_mod_loan_from_markaz" ||
        notificationName === "req_mod_reimbursment_tarbiati_course" ||
        notificationName === "req_mod_help_from_muqami_tanzeem" ||
        notificationName === "req_amanat_to_cash_in_hand" ||
        notificationName === "req_edit_amanat_to_cash_in_hand" ||
        notificationName === "req_cash_to_amanat_transfer" ||
        notificationName === "req_edit_cash_to_amanat_transfer" ||
        notificationName === "req_cash_in_hand_to_amanat" ||
        notificationName === "req_infaq_to_amanat_account" ||
        notificationName === "req_edit_infaq_to_amanat_account" ||
        notificationName === "req_halqa_share" ||
        notificationName === "req_edit_halqa_share" ||
        notificationName === "req_delete_halqa_share" ||
        notificationName === "req_markaz_share" ||
        notificationName === "req_edit_markaz_share" ||
        notificationName === "req_delete_markaz_share";
      const responseData = res?.data;
      const message = isFinanceNotification
        ? responseData?.message || ""
        : typeof responseData === "string"
          ? responseData
          : responseData?.message || "";
      const status = isFinanceNotification
        ? Number(responseData?.statusCode) !== 200
          ? "error"
          : message.includes("Reject")
            ? "error"
            : message.includes("Hold")
              ? "warning"
              : "success"
        : message.includes("Reject")
          ? "error"
          : message.includes("Hold")
            ? "warning"
            : "success";

      if (status) {
        const isOtherIncomeNotification =
          notificationName === "req_loan_from_markaz" ||
          notificationName === "req_reimbursment_tarbiati_course" ||
          notificationName === "req_help_from_muqami_tanzeem";

        const shouldShowReceiptButton =
          isOtherIncomeNotification &&
          Number(responseData?.statusCode) === 200 &&
          responseData?.transactionNo &&
          Number(responseData?.transactionNo) !== 0;

        const viewReceipt = () =>
          viewReceiptPdf({
            transactionNo: responseData.transactionNo,
            type: "otherIncome",
            t,
          }).catch(() => false);

        let swalText = "";
        if (responseData?.warning) {
          swalText = t(responseData.warning) || responseData.warning;
        }

        swal({
          title: t(message),
          text: swalText || undefined,
          icon: responseData?.warning && status === "success" ? "warning" : status,
          buttons: shouldShowReceiptButton
            ? {
              OK: true,
              viewReceipt: {
                text: t("common_view_receipt") || "View Receipt",
                value: "viewReceipt",
              },
            }
            : "OK",
          className: GetSelectedLanguage() === "en" ? "en" : "ur",
        }).then((value) => {
          if (value === "viewReceipt") {
            viewReceipt();
          }
          setRefreshList((prev) => !prev);
        });
      }
    } catch (err) {
      console.error(err);
      const serverMessage =
        err.response?.data?.message ||
        err.response?.data?.Message ||
        (typeof err.response?.data === "string" ? err.response.data : null) ||
        err.message ||
        "Something went wrong. Please try again.";

      swal({
        title: typeof serverMessage === "string" ? (t(serverMessage) || serverMessage) : "Something went wrong.",
        icon: "error",
        buttons: "OK",
        className: GetSelectedLanguage() === "en" ? "en" : "ur",
      });
    } finally {
      setState((prev) => ({ ...prev, loading: false }));
      setActionModal(false);
    }
  };

  return (
    <div>
      <Draggable
        position={state.position}
        onDrag={handleDrag}
        handle=".modal-header"
        cancel=".no-drag"
      >
        <Modal
          isOpen={true}
          size={notificationName.includes("responsibility") ? "lg" : "xl"}
          className="inmodal"
        >
          <ModalHeader className="modal-title" tag="h4">
            {<GetLanguageString props="common_action" />}
          </ModalHeader>
          <Form onSubmit={handleSubmit}>
            <ModalBody>
              {!state.loading ? (
                <>
                  {isMemberMubtadi ? (
                    <h3 className="text-center text-error ur">
                      {notificationName.includes("exception")
                        ? `یہ رفیق (${memberName}) مبتدی ہیں`
                        : !isNotificationForwarded
                          ? `یہ رفیق (${memberName}) مبتدی ہیں، استثناء کی درخواست بھیجیں`
                          : `یہ رفیق (${memberName}) مبتدی ہیں، استثناء کی درخواست گئی ہوئی ہے`}
                    </h3>
                  ) : null}

                  <div className="ibox-content">
                    {/* Action Radio Buttons */}
                    <FormGroup>
                      <Label className="m-0">
                        <h4>{<GetLanguageString props="common_action" />}</h4>
                      </Label>
                      <Row>
                        {!isNotificationForwarded ||
                          notificationName.includes("req_move_member") ? (
                          <Col md="4" className="text-center">
                            <Label className="col-form-label">
                              <Input
                                type="radio"
                                name="code"
                                className="m-1"
                                value={ACTION_TYPES.APPROVE}
                                checked={state.defaulValue}
                                onChange={() =>
                                  handleApprovalStatus(ACTION_TYPES.APPROVE)
                                }
                              />{" "}
                              {isMemberMubtadi &&
                                !notificationName.includes("exception") ? (
                                <GetLanguageString props="member__request_responsibility_request_for_exception" />
                              ) : notificationName.includes(
                                "req_mark_rafiq_ex_halqa_level",
                              ) ||
                                notificationName.includes(
                                  "req_mark_rafiq_ex_naib_nazim_alla_level",
                                ) ? (
                                <GetLanguageString props="notifications_forward_request" />
                              ) : notificationName.includes(
                                "member_type_change_request",
                              ) && unitTypeName !== "Markaz" ? (
                                <GetLanguageString props="notifications_forward_request" />
                              ) : (notificationName === "req_halqa_share" && isAmanatShare && unitTypeName === "Halqa") ? (
                                <GetLanguageString props="notifications_forward_request" />
                              ) : ((notificationName === "req_expense_from_amanat" || notificationName === "req_edit_expense_from_amanat") && (unitTypeName === "Tanzeem" || unitTypeName === "Halqa")) ? (
                                <GetLanguageString props="notifications_forward_request" />
                              ) : (notificationName === "req_delete_halqa_share" || notificationName === "req_delete_markaz_share") ? (
                                 <GetLanguageString props="approve_deletion" />
                              ) : (
                                <GetLanguageString props="notifications_action_approve" />
                              )}
                            </Label>
                          </Col>
                        ) : null}
                        <Col
                          md={
                            !isNotificationForwarded ||
                              notificationName.includes("req_move_member")
                              ? "4"
                              : "6"
                          }
                          className="text-center"
                        >
                          <Label className="col-form-label">
                            <Input
                              type="radio"
                              name="code"
                              className="m-1"
                              value={ACTION_TYPES.REJECT}
                              onChange={() =>
                                handleApprovalStatus(ACTION_TYPES.REJECT)
                              }
                            />{" "}
                            {
                              <GetLanguageString props="notifications_action_reject" />
                            }
                          </Label>
                        </Col>
                        <Col
                          md={
                            !isNotificationForwarded ||
                              notificationName.includes("req_move_member")
                              ? "4"
                              : "6"
                          }
                          className="text-center"
                        >
                          <Label className="col-form-label">
                            <Input
                              type="radio"
                              name="code"
                              className="m-1"
                              value={ACTION_TYPES.HOLD}
                              onChange={() =>
                                handleApprovalStatus(ACTION_TYPES.HOLD)
                              }
                            />{" "}
                            {<GetLanguageString props="notifications_hold" />}
                          </Label>
                        </Col>
                      </Row>
                    </FormGroup>

                    {/* Extra Fields */}
                    {notificationName.includes(
                      "req_mark_rafiq_ex_halqa_level",
                    ) ? (
                      <Row>
                        <Label className="col-form-label ur">
                          <h4>
                            مقامی امیر نے متعلقہ رفیق تنظیم سے اخراج/معذرت کے جو
                            احوال بتائے ہیں آپ ان سے مطمئن ہیں، تفصیل سے آگاہ
                            فرمائیں
                          </h4>
                          <Input
                            type="text"
                            name="feedback"
                            className={`no-drag ${isUrdu(state.notificationAction.feedback)
                              ? "ur"
                              : ""
                              }`}
                            value={getStringFromJSX(
                              applyClassToCharacters(
                                state.notificationAction.feedback,
                                "ur",
                              ),
                            )}
                            onChange={handleInputChange}
                          />
                        </Label>
                      </Row>
                    ) : notificationName.includes(
                      "req_mark_rafiq_ex_nazim_alla_level",
                    ) ? (
                      <Row>
                        <Col md="6">
                          <Label className="col-form-label ur">
                            <h4>
                              اخراج کی سفارش کی صورت میں رفیق کو خط تحریر کرنے
                              کی تاریخ
                            </h4>
                          </Label>
                          <DatePicker
                            showYearDropdown
                            dropdownMode="select"
                            placeholderText="dd/mm/yyyy"
                            maxDate={new Date()}
                            className="form-control"
                            selected={state.letterWrittenDate}
                            onChange={handleDateChange}
                            dateFormat="dd/MM/yyyy"
                          />
                        </Col>
                        <Col md="6">
                          <Label className="col-form-label ur">
                            <h4>رفیق کا جواب موصول ہوا</h4>
                          </Label>
                          <Row>
                            <Col md="6">
                              <Input
                                type="radio"
                                name="answerFromRafiq"
                                id="answerFromRafiqYes"
                                className="form-check-input"
                                checked={
                                  state.notificationAction.answerFromRafiq
                                }
                                onChange={() => handleAnswerFromRafiq(true)}
                              />
                              &nbsp;&nbsp;
                              <Label
                                check
                                className="form-check-label ur"
                                htmlFor="answerFromRafiqYes"
                              >
                                جی ہاں
                              </Label>
                            </Col>
                            <Col md="6">
                              <Input
                                type="radio"
                                name="answerFromRafiq"
                                id="answerFromRafiqNo"
                                className="form-check-input"
                                checked={
                                  !state.notificationAction.answerFromRafiq
                                }
                                onChange={() => handleAnswerFromRafiq(false)}
                              />
                              &nbsp;&nbsp;
                              <Label
                                check
                                className="form-check-label ur"
                                htmlFor="answerFromRafiqNo"
                              >
                                جی نہیں
                              </Label>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    ) : notificationName.includes(
                      "member_type_change_request_multazim",
                    ) &&
                      unitTypeName === "Tanzeem" &&
                      !isNotificationForwarded ? (
                      <Row>
                        <Label className="col-form-label ur">
                          <h4>تاثرات و سفارش (برا ئے اجراء ساولنامہ ) </h4>
                          <Input
                            type="text"
                            name="feedback"
                            className={`no-drag ${isUrdu(state.notificationAction.feedback)
                              ? "ur"
                              : ""
                              }`}
                            value={getStringFromJSX(
                              applyClassToCharacters(
                                state.notificationAction.feedback,
                                "ur",
                              ),
                            )}
                            onChange={handleInputChange}
                          />
                        </Label>
                      </Row>
                    ) : null}
                    {/* Comments */}
                    <Row>
                      <Label className="col-form-label">
                        <h4>
                          {
                            <GetLanguageString props="member_member_detail_course_comments" />
                          }
                        </h4>
                        <Input
                          type="text"
                          name="comments"
                          className={`no-drag ${isUrdu(state.notificationAction.feedback)
                            ? "ur"
                            : ""
                            }`}
                          value={getStringFromJSX(
                            applyClassToCharacters(
                              state.notificationAction.comments,
                              "ur",
                            ),
                          )}
                          onChange={handleInputChange}
                        />
                      </Label>
                    </Row>
                    {hasBankDetails &&
                      state.notificationAction.code === ACTION_TYPES.APPROVE &&
                      !((notificationName === "req_expense_from_amanat" || notificationName === "req_edit_expense_from_amanat") && (unitTypeName === "Tanzeem" || unitTypeName === "Halqa")) && (
                      <Row className="mt-3">
                        <Col md="12">
                          <FormGroup>
                            <Label className="col-form-label" style={{ fontWeight: "bold" }}>
                              <GetLanguageString props="funds_dimension_2" />
                            </Label>
                            <Select
                              options={dimension2Options}
                              value={selectedDimension2}
                              getOptionValue={(opt) => opt.value}
                              getOptionLabel={(opt) => opt.label}
                              onChange={(val) => {
                                setSelectedDimension2(val);
                                setDimension2Error("");
                              }}
                              placeholder={t("member_select")}
                              className="no-drag"
                              classNamePrefix="select"
                            />
                            <div className="text-muted mt-1" style={{ fontSize: "11.5px", fontStyle: "italic" }}>
                              {<GetLanguageString props="dimension2_approval_hint" />}
                            </div>
                            {bankDetails && (!selectedDimension2 || !selectedDimension2.label || !bankDetails.rafiqAccountNumber || !selectedDimension2.label.includes(bankDetails.rafiqAccountNumber.trim())) && (
                              <><hr /><div className="alert alert-default p-3 mb-3 no-drag" style={{ fontSize: "12.5px", borderRadius: "8px", borderLeft: "4px solid #17a2b8" }}>
                                <i className="fa fa-info-circle mr-2 text-default" style={{ fontSize: "15px" }}></i>
                                <strong> Note:</strong> Please select Dimension 2 for this request before proceeding. If a Dimension 2 head does not exist for this bank account, please create it first with these bank details:
                                <div className="mt-2 pl-3" style={{ borderLeft: "2px solid #ced4da" }}>
                                  {bankDetails.vendorName && <div>• <strong>Vendor Name:</strong> {bankDetails.vendorName}</div>}
                                  {bankDetails.isFiler !== undefined && (
                                    <div>• <strong><GetLanguageString props="tax_status" />:</strong> <span className={`badge ${bankDetails.isFiler ? "badge-primary" : "badge-warning"}`} style={{ fontSize: "11px", padding: "2px 8px" }}>{bankDetails.isFiler ? <GetLanguageString props="tax_status_filer" /> : <GetLanguageString props="tax_status_non_filer" />}</span></div>
                                  )}
                                  {bankDetails.ntnNumber ? (
                                    <div>• <strong>Vendor NTN:</strong> {bankDetails.ntnNumber} (Company/Organization)</div>
                                  ) : bankDetails.cnic ? (
                                    <div>• <strong>{bankDetails.vendorName ? "Vendor CNIC" : "CNIC"}:</strong> {bankDetails.cnic} {bankDetails.vendorName ? "(Individual)" : ""}</div>
                                  ) : null}
                                  <div>• <strong>Account Title:</strong> {bankDetails.rafiqAccountTitle || "-"}</div>
                                  <div>• <strong>Account Number:</strong> {bankDetails.rafiqAccountNumber || "-"}</div>
                                  <div>• <strong>Bank Name:</strong> {bankDetails.rafiqBankName || "-"}</div>
                                </div>
                              </div></>
                            )}
                            {dimension2Error && (
                              <h4 className="text-error mt-1">{dimension2Error}</h4>
                            )}
                          </FormGroup>
                        </Col>
                      </Row>
                    )}


                  </div>

                  <br />

                  {/* Extra Inputs based on Action */}
                  {state.notificationAction.code === ACTION_TYPES.APPROVE ? (
                    notificationName.includes("move") ? (
                      <>
                        <div className="ibox-title">
                          <h4>
                            {
                              <GetLanguageString props="notification_select_unit" />
                            }
                          </h4>
                        </div>
                        <div className="ibox-content">
                          <SelectUnitRequestMoveMember
                            values={state}
                            setValues={setState}
                            setNotificationAction={(fn) =>
                              setState((prev) => ({
                                ...prev,
                                notificationAction:
                                  typeof fn === "function"
                                    ? fn(prev.notificationAction)
                                    : fn,
                              }))
                            }
                            unitId={unitId}
                            setErrors={setErrors}
                            errors={errors}
                            canBeTransferredOutside={canBeTransferredOutside}
                            showExcludeUnit={false}
                          />
                        </div>
                      </>
                    ) : notificationName.includes("add_new_rafiq") ? (
                      <div className="ibox-content">
                        <SelectSerialNumber
                          setSerialNumber={setSerialNumber}
                          loading={state.loading}
                        />
                      </div>
                    ) : null
                  ) : null}
                </>
              ) : (
                LoadingSpinner()
              )}
            </ModalBody>
            <ModalFooter>
              <Button color="white" onClick={toggle}>
                {<GetLanguageString props="common_cancel" />}
              </Button>
              <Button
                color="primary"
                disabled={state.buttonDisable}
                type="submit"
              >
                {<GetLanguageString props="common_save_changes" />}
              </Button>
            </ModalFooter>
          </Form>
        </Modal>
      </Draggable>
    </div>
  );
};

export default NotificationAction;
